@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.admin.support

import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.support.SupportCategoryDto

object UpsertSupportCategoryEndpoint : EndPoint<UpsertSupportCategoryEndpoint.Request, UpsertSupportCategoryEndpoint.Response>() {
    class Request(
        val supportCategory: SupportCategoryDto
    )

    class Response()
}